// src/utils/dateUtils.js
export const formatDate = (dateInput) => {
  if (!dateInput) return "—";
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("da-DK", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatDateWithoutYear = (dateInput) => {
  if (!dateInput) return "—";
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("da-DK", {
    day: "2-digit",
    month: "2-digit",
  });
};

export const formatDateRange = (start, end) => {
  if (!start && !end) return "—";
  const s = start ? formatDate(start) : "—";
  const e = end ? formatDate(end) : "—";
  return `${s} → ${e}`;
};
